import { useCallback } from 'react';

export {};

export function useDispatch() {
  const dispatch = useCallback(function _dispatch(thunk) {
    return thunk(_dispatch);
  }, []);

  return dispatch;
}
